module.exports = __webpack_public_path__ + "static/media/SFCompactDisplay-UltraLight.bdbdfc79.ttf";